import styled from 'styled-components';
import colors from '../../../../includes/colors';
import { Button } from 'reactstrap';

export const Box = styled.div`
  @media (min-width: 992px) {
    border: solid 1px #aaa;
  }
`;

export const Icon = styled.span`
  color: ${colors.blue};
  font-size: 2.25rem !important;
  transform: translateY(5px);
  display: inline-block;
`;

export const Label = styled.label`
  font-size: 0.875rem;
`;

export const Title = styled.h2`
  color: ${colors.black};
  line-height: 2rem;
  font-weight: 300;
  font-size: 1.25rem;
  @media (min-width: 576px) {
    font-size: 1.625rem;
  }
  @media (min-width: 992px) {
    font-size: 1.75rem;
  }
`;

export const AllFAQLink = styled.a`
  font-size: 0.875rem;
`;

export const LinkRow = styled.div`
  border-top: solid 1px #aaa;
  & > div {
    @media (max-width: 480px) {
      flex-basis: 100%;
      max-width: 100%;
      &:nth-child(2) {
        margin-top: 1rem !important;
      }
    }
  }
`;

export const BottomLink = styled.a`
  font-size: 1.125rem;
`;

export const ButtonFaq = styled(Button)`
  line-height: 1.7rem;
`;

export const ButtonBox = styled.div`
  @media (max-width: 767px) {
    flex-basis: 100%;
  }
`;

export const Disclaimer = styled.p`
  padding-top: 1rem;
  margin-bottom: 0;
  font-size: 0.875rem; 
`
